import { apiClientCarts } from './apiClientCarts'
import { apiOrderClient } from './apiOrderClient'
import { apiOrderDays } from './apiOrderDays'
import { apiOrderDeliveries } from './apiOrderDeliveries'
import { apiOrders } from './apiOrders'
import { apiCartBlockedDates } from './apiCartBlockedDates'
import { apiExternalOrders } from './apiExternalOrders'
import { apiInternalOrders } from './apiInternalOrders'
import { apiClientCartsToPay } from './apiClientCartsToPay'

const apiOrdersGroup = {
	...apiOrders,
	...apiClientCarts,
	...apiOrderDays,
	...apiOrderDeliveries,
	...apiOrderClient,
	...apiCartBlockedDates,
	...apiExternalOrders,
	...apiInternalOrders,
	...apiClientCartsToPay,
}

export { apiOrdersGroup }
